import { useRef } from "react";

import { BoxFlagControl } from "../../../Blocks/Composites/BoxFlagControl/BoxFlagControl";
import { isNullish, Tooltip } from "@theorgchartdev/storybook";
import { UpdateBoxProperty } from "@/Utils/StateLib";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { enumFlagType, enumUpdateProperty } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { editModeTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";

const UpdateBoxFlag = result => {
  result.fFlagType = enumFlagType.triupperright;

  if (
    isNullish(result.fFlagColor1) &&
    isNullish(result.fFlagColor2) &&
    isNullish(result.fFlagLabel)
  ) {
    result.fFlagType = enumFlagType.none;
  }

  UpdateBoxProperty(enumUpdateProperty.boxFlag, result);
};

export const BoxFlagComposite = ({ dataTestId } = {}) => {
  const openCtrlRef = useRef(null);
  const wsMgrContext = useWSMgrContext();
  const wsMgr = wsMgrContext?.wsMgr.state;

  if (!wsMgr) {
    return;
  }

  const boxFlagValue = wsMgr.SurveySelection(enumUpdateProperty.boxFlag);
  if (boxFlagValue == null) return;
  const handleChange = newValue => {
    UpdateBoxFlag(newValue);
  };

  return (
    <Tooltip
      title={appstr("Box Flag")}
      message={appstr("Configure a flag and label for the selected boxes")}
      referenceOpenCtrlRef={openCtrlRef}
    >
      <BoxFlagControl
        openCtrlRef={openCtrlRef}
        dataTestId={dataTestId ?? editModeTestId("box-flag")}
        referenceProps={{ size: "small" }}
        value={boxFlagValue}
        onChange={handleChange}
      />
    </Tooltip>
  );
};
